<template>
  <div class="label">
    <p class="label__split label__split__left">{{ titleLeft }}</p>
    <p class="label__split label__split__right">{{ titleRight }}</p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { INDOORVIEWER_PREFIX } from '@/store/module-prefixes'

const store = useStore()

const instanceLinks = computed(() => store.state[INDOORVIEWER_PREFIX].instanceLinks)
const primaryInstance = computed(() => store.state[INDOORVIEWER_PREFIX].primaryInstance)
const secondaryInstance = computed(() => store.state[INDOORVIEWER_PREFIX].secondaryInstance)

const titleLeft = computed(() => {
  return instanceLinks.value[primaryInstance.value].title ?? `Site ${primaryInstance.value + 1}`
})
const titleRight = computed(() => {
  return instanceLinks.value[secondaryInstance.value].title ?? `Site ${secondaryInstance.value + 1}`
})
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
@use '@/styles/variables.scss' as old-variables;
.label {
  display: flex;
  position: fixed;
  text-align: center;
  top: #{variables.$layout-top-bar-height};
  width: 100%;
  p {
    @include font-mixins.desktop-regular-paragraph;
    color: variables.$color-pure-white;
    line-height: old-variables.$margin-medium; // Using margin as field height, since it should fit between buttons and top bar
  }
  &__split {
    background: old-variables.$color-background-navigation-menu;
    height: old-variables.$margin-medium; // Using margin as field height, since it should fit between buttons and top bar
    margin: 0;
    position: absolute;
    width: calc(50% - 2px);
    &__left {
      left: 0;
    }
    &__right {
      left: calc(50% + 2.5px);
    }
  }
}
</style>
